import { Box, Center, Flex, Text, BoxProps } from "@chakra-ui/react";
import { DoubleArrowDown } from "assets";
// import { format, parseISO } from "date-fns";
import { IStatus } from "interfaces";
import { transferStatusColor } from "utils";

interface IProps extends BoxProps {
  direction: "in" | "out";
  fiatAmount: number;
  fiatType: string;
  cryptoVolume: number;
  description: string;
  status: IStatus["status"];
  crypto: string;
  createdAt: string;
  _id: string;
}
const CicoTransferCard = ({
  fiatAmount,
  description,
  status,
  fiatType,
  direction,
  crypto,
  createdAt,
  cryptoVolume,
  ...props
}: IProps) => {
  return (
    <Flex
      bg="#FBFBFB"
      borderRadius="5px"
      mb="12px"
      alignItems="center"
      justifyContent="space-between"
      padding="10px 9px"
      cursor="pointer"
      {...props}
    >
      <Flex gridGap="13px" alignItems="center">
        <Center
          width={{ base: "24px", "1sm": "29px" }}
          height={{ base: "24px", "1sm": "29px" }}
          borderRadius="full"
          bg={direction === "in" ? "#E2F2DA" : "linear-gradient(0deg, rgba(237, 28, 0, 0.5), rgba(237, 28, 0, 0.5)), #FFFFFF;"}
        >
          {direction === "in" ? <DoubleArrowDown /> : <DoubleArrowDown />}
        </Center>

        <Box>
          <Text fontSize={{ base: "14px", "1sm": "16px" }} fontWeight="700" mb="4px">
            {cryptoVolume} {crypto}
          </Text>

          <Text fontSize="12px" fontWeight="400">
            {fiatType} {Number(fiatAmount).toLocaleString()}
          </Text>
        </Box>
      </Flex>

      {/* <Text fontSize={{ base: "12px", "1sm": "14px" }}>{format(parseISO(createdAt), "dd-MM-yyyy")}</Text> */}
      <Box>
        <Text textAlign="left" fontSize="12px" fontWeight="600" color={transferStatusColor(status)}>
          {status}
        </Text>
      </Box>
    </Flex>
  );
};

export default CicoTransferCard;
